import { render, staticRenderFns } from "./subordinatePolicyDetails.vue?vue&type=template&id=c438ca56&scoped=true"
import script from "./subordinatePolicyDetails.vue?vue&type=script&lang=js"
export * from "./subordinatePolicyDetails.vue?vue&type=script&lang=js"
import style0 from "./subordinatePolicyDetails.vue?vue&type=style&index=0&id=c438ca56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c438ca56",
  null
  
)

export default component.exports